// extracted by mini-css-extract-plugin
export var Error = "Error-module--Error--3p6Fh";
export var aniSpin = "Error-module--ani-spin--A5Pnp";
export var container = "Error-module--container--0PMbc";
export var heading = "Error-module--heading--3KuEL";
export var message = "Error-module--message--ArSGH";